module.exports = __webpack_public_path__ + "static/media/feiLogo.ee8047ff.png";